var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Main Panel "+_vm._s(_vm.env))]),_c('v-btn',{on:{"click":_vm.loadUsers}},[_vm._v("Load Users")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }